/*    
<summary>
   This class component is all about Managing Test functionality.
</summary>
<param>No Parameter Passed</param>
<returns>Returns class instance</returns>
*/
import { action, computed, makeObservable, observable, toJS } from 'mobx';
import URLConstants from '../../constants/url.constants';
import * as baseService from '../service/base-service';
import { ITestState } from '../../models/state/ITestState';
import { ICommonState } from '../../models/state/ICommonState';
import toast from "react-hot-toast";
import { formatMessage } from '../../translations/format-message';
import { TestType } from '../../constants/enum';
import { initialState as GetAllQuestionsInitialState } from '../initial-state/get-all-question-state';
import { initialState as GetTestInterpretationInitialState } from '../initial-state/get-test-interpretation-state';
import IQuestionInfo, { IGetAllQuestions } from '../../models/response/ITestQuestion';
import { ICategoryInfo, IGetTestInterpretation, ISurveyQuestionInfo, ITwoDiGraphInfo } from '../../models/response/ITestInterpretation';
import { ITestInfo } from '../../models/ITestInfo';
import Highcharts from 'highcharts';
import IApiResponse, { IApiSuccessResponse } from '../../models/response/IApiResponse';
//import { initialState as GetAllGraphInitialState } from '../initial-state/get-all-graph-state';

export class TestStore implements ITestState, ICommonState {
    questionDataList: IGetAllQuestions = GetAllQuestionsInitialState;
    resultDataList: IGetAllQuestions = GetAllQuestionsInitialState;
    testInterpretationDataList: IGetTestInterpretation = GetTestInterpretationInitialState;
    colorsAsString: Highcharts.ColorType[] = [];

    inProgress = false;
    error = '';
    // allQuestionList: any[] = [];

    initialStateValue = {
        success: false,
        error: '',
        inProgress: false
    }

    initialTestSubmitStateValue = {
        success: false,
        error: '',
        inProgress: false,
        testId: -1
    }

    testLayoutState = { ...this.initialStateValue }

    getGraphState = { ...this.initialStateValue }

    testInterpratationState = { ...this.initialStateValue};

    testUserState = { ...this.initialTestSubmitStateValue }

    IsValidTestToken = {...this.initialStateValue};

    constructor() {
        makeObservable(this, {
            testLayoutState: observable,
            testUserState: observable,
            questionDataList: observable,
            resultDataList: observable,
            getGraphState: observable,
            testInterpratationState: observable,
            testInterpretationDataList: observable,
            IsValidTestToken:observable,
            getAllQuestions: action,
            resetAllQuestions: action,
            submitTest: action,
            resetTestState: action,
            getFreeTestInterpretation: action,
            getTestInterpretation: action,
            resetTestInterpretation: action,
            allQuestionList: computed,
            allResultList: computed,
            allGraphData: computed,
            allSurveyData: computed,
            allTestInfo: computed,
            allTwoDiResult: computed,
            generateRandomColor: action,
            generateHighchartColorPallete: action
        });

        // On init, generate 10 colors from the Highchart.
        this.generateHighchartColorPallete();
    }

    resetTestInterpretation = () => {
        this.testInterpretationDataList = GetTestInterpretationInitialState;
        this.testInterpratationState = { ...this.initialStateValue};
    }

    getAllQuestions = (testType: TestType, token:string|undefined) => {
        this.testLayoutState.inProgress = true;
        var url = "";
        if(token != undefined || token!=null){
            url = `${URLConstants.TestLayout}?testName=${TestType[testType].toString()}&token=${token}`
        }
        else{
            url = `${URLConstants.TestLayout}?testName=${TestType[testType].toString()}`
        }
        return baseService.getRequest(url)
            .then((response: any) => {
                
                if(response.data.Error){
                    this.testLayoutState.error = "Token Expired"
                }
                else{
                    this.testLayoutState.success = true;
                    this.questionDataList = JSON.parse(response.data.Data);

                }
                // .then((response: IApiResponse<IApiSuccessResponse<IAddUser>>) => {
                // console.log(JSON.parse(response.data.Data));
                // console.log(toJS(this.questionDataList));
            })
            .catch((err: string) => {
                this.testLayoutState.success = false;
                this.testLayoutState.error = err;
                toast.error(formatMessage(err));
            })
            .finally(action(() => {
                this.testLayoutState.inProgress = false;
            }));
    };

    resetAllQuestions = () => {
        this.testLayoutState = {...this.initialStateValue};
        this.questionDataList = GetAllQuestionsInitialState;
    }

    getTestAnswers = (testId: any) => {
        this.testUserState.inProgress = true;
        this.resultDataList = GetAllQuestionsInitialState;
        var url = `${URLConstants.GetTestScore}/?testId=${testId}`;
        return baseService.getRequest(url)
            .then((response: any) => {
                this.resultDataList.Questions = JSON.parse(response.data.Data['TestScore']);
                this.resultDataList.TestType = response.data.Data['TestType'];
            })
            .catch((err: string) => {
                // this.testUserState.success = false;
                // this.testUserState.error = err;
                toast.error(formatMessage(err));
            })
            .finally(action(() => {
                // this.testUserState.inProgress = false;
            }));

    }

    submitTest = (testJSON: string, testType: TestType, testToken: string|undefined, eventId: number|undefined) => {
        this.testUserState.inProgress = true;
        var url = `${URLConstants.TestLayout}`
        const data = {
            TestType: testType,
            TestScore: testJSON,
            Token: testToken,
            EventId: eventId ? Number(eventId) : 0
        };

        return baseService.postRequest(url, data)
            .then((response: any) => {
                // console.log(response);
                this.testUserState.success = true;
                this.testUserState.testId = parseInt(response.data.Message);
                // console.log("success");
                // this.questionDataList = JSON.parse(response.data.Data);
                // // .then((response: IApiResponse<IApiSuccessResponse<IAddUser>>) => {
                // //this.addUpdateUserState.success = true;
                // console.log(JSON.parse(response.data.Data));
                // console.log(toJS(this.questionDataList));
            })
            .catch((err: string) => {
                this.testUserState.success = false;
                this.testUserState.error = err;
                toast.error(formatMessage(err));
            })
            .finally(action(() => {
                this.testUserState.inProgress = false;
            }));
    }

    getFreeTestInterpretation = (testJSON: string, testType: TestType, testDate: string) => {
        this.testInterpratationState.inProgress = true
        var url = `${URLConstants.GetFreeTestInterpretation}`
        const data = {
            TestType: testType,
            TestScore: testJSON,
            TestDate: testDate
        };

        return baseService.postRequest(url, data)
            .then((response: any) => {
                if (response.data.Error) {
                    this.testInterpratationState.error = response.data.Message
                    toast.error(formatMessage(response.data.Message));
                }
                else {
                    const responseData = JSON.parse(response.data.Data);
                    // console.log(responseData);
                    this.testInterpretationDataList.BarScatterGraph_Result = responseData.TestResultBar_Scatter_GraphVM;
                    this.testInterpretationDataList.SurveyQuestion_Result = responseData.TestResultVMSurvey;
                    this.testInterpretationDataList.TwoDiGraph_Result.TestResult_2DGraphVM = responseData.TestResult_2DGraphVM;
                    this.testInterpretationDataList.UserInfo_Result = responseData.TestResult_UserInfoVM;
                    this.testInterpretationDataList.IsSogileBurnout = responseData.IsSogileBurnoutCase;
                    this.testInterpratationState.success = true;
                    // console.log(toJS(this.testInterpretationDataList));
                }
            })
            .catch((err: string) => {
                this.testInterpratationState.success = false;
                this.testInterpratationState.error = err;
                toast.error(formatMessage(err));
            })
            .finally(action(() => {
                this.testInterpratationState.inProgress = false;
            }));

    }

    resetTestState = () => {
        this.testUserState = {...this.initialTestSubmitStateValue}
    }

    getTestInterpretation = (testIds: Array<number>): any => {
        this.testInterpratationState.inProgress = true
        const testIdUrl = testIds.join('%26'); //%26 = &
        const url = `${URLConstants.GetTestInterpretation}?testIds=${testIdUrl}`;
        return baseService.getRequest(url)
            .then((response: any) => {
                if (response.data.Error) {
                    this.testInterpratationState.error = response.data.Message
                    toast.error(formatMessage(response.data.Message));
                }
                else {
                    const responseData = JSON.parse(response.data.Data);
                    // console.log(responseData);
                    this.testInterpretationDataList.BarScatterGraph_Result = responseData.TestResultBar_Scatter_GraphVM;
                    this.testInterpretationDataList.SurveyQuestion_Result = responseData.TestResultVMSurvey;
                    this.testInterpretationDataList.TwoDiGraph_Result.TestResult_2DGraphVM = responseData.TestResult_2DGraphVM;
                    this.testInterpretationDataList.UserInfo_Result = responseData.TestResult_UserInfoVM;
                    this.testInterpretationDataList.IsSogileBurnout = responseData.IsSogileBurnoutCase;
                    this.testInterpratationState.success = true;
                    // console.log(toJS(this.testInterpretationDataList));
                }
            })
            .catch((err: string) => {
                this.testInterpratationState.success = false;
                this.testInterpratationState.error = err;
                toast.error(formatMessage(err));
            })
            .finally(action(() => { 
                this.testInterpratationState.inProgress = false; 
            }));
    }


    getDummyTestResult = (): any => {
        const dataAsStr = `{"IsSogileBurnoutCase":false,"TestResult_UserInfoVM":{"TestDataListVM":[{"TestId":16120,"TestType":"LIFE","TestDate":"1723038752","UserId":0,"UserEmail":"arjun.thakur@meritech.co.in","TrainerId":null,"InviteId":null,"IsPaidTest":false,"FirstName":"Arjun","LastName":"Thakur"}]},"TestResultBar_Scatter_GraphVM":{"CategoryList":[{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"CR_QN","DetailsHidden_Key":"CR_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_CH_R_R_H"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_CH_R_CH_L"}],"CategoryKey":"CH_R","SubCategoryList":[{"SubCategoryKey":"CH_R_CH","SubCategory_Details_Key":"CR_V_HD","Results":[{"TestId":16120,"Result":43}]},{"SubCategoryKey":"CH_R_R","SubCategory_Details_Key":"CR_R_HD","Results":[{"TestId":16120,"Result":57}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"IS_QN","DetailsHidden_Key":"IS_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_INFO_D_H"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_INFO_B_L"}],"CategoryKey":"INFO","SubCategoryList":[{"SubCategoryKey":"INFO_D","SubCategory_Details_Key":"IS_D_HD","Results":[{"TestId":16120,"Result":56}]},{"SubCategoryKey":"INFO_B","SubCategory_Details_Key":"IS_BP_HD","Results":[{"TestId":16120,"Result":44}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"PC_QN","DetailsHidden_Key":"PC_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_VAK_V_H"},{"Order":1,"Type":"Single_Balance","Observation_Key":"LIFE_VAK_A_B"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_VAK_K_L"}],"CategoryKey":"VAK","SubCategoryList":[{"SubCategoryKey":"VAK_V","SubCategory_Details_Key":"V_HD","Results":[{"TestId":16120,"Result":57}]},{"SubCategoryKey":"VAK_A","SubCategory_Details_Key":"ATY_HD","Results":[{"TestId":16120,"Result":51}]},{"SubCategoryKey":"VAK_K","SubCategory_Details_Key":"KC_HD","Results":[{"TestId":16120,"Result":42}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"IR_QN","DetailsHidden_Key":"IR_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_REF_I_H"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_REF_E_L"}],"CategoryKey":"REF","SubCategoryList":[{"SubCategoryKey":"REF_I","SubCategory_Details_Key":"IR_I_HD","Results":[{"TestId":16120,"Result":68}]},{"SubCategoryKey":"REF_E","SubCategory_Details_Key":"IR_E_HD","Results":[{"TestId":16120,"Result":32}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"C_QN","DetailsHidden_Key":"C_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_CAR_S_H"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_CAR_O_L"}],"CategoryKey":"CAR","SubCategoryList":[{"SubCategoryKey":"CAR_S","SubCategory_Details_Key":"S_HD","Results":[{"TestId":16120,"Result":53}]},{"SubCategoryKey":"CAR_O","SubCategory_Details_Key":"O_HD","Results":[{"TestId":16120,"Result":47}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"R_A-O_QN","DetailsHidden_Key":"R_A-O_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_RC_AG_H"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_RC_OP_L"}],"CategoryKey":"RC","SubCategoryList":[{"SubCategoryKey":"RC_AG","SubCategory_Details_Key":"A_HD","Results":[{"TestId":16120,"Result":77}]},{"SubCategoryKey":"RC_OP","SubCategory_Details_Key":"OPP_HD","Results":[{"TestId":16120,"Result":23}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"D_AT_QN","DetailsHidden_Key":"D_AT_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_DIR_A_H"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_DIR_T_L"}],"CategoryKey":"DIR","SubCategoryList":[{"SubCategoryKey":"DIR_A","SubCategory_Details_Key":"AY_HD","Results":[{"TestId":16120,"Result":62}]},{"SubCategoryKey":"DIR_T","SubCategory_Details_Key":"TS_HD","Results":[{"TestId":16120,"Result":38}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"TS_C-A_QN","DetailsHidden_Key":"TS_C-A_HD","Observations":[{"Order":1,"Type":"Single_Balance","Observation_Key":"LIFE_THKS_C_B"},{"Order":1,"Type":"Single_Balance","Observation_Key":"LIFE_THKS_A_B"}],"CategoryKey":"THKS","SubCategoryList":[{"SubCategoryKey":"THKS_C","SubCategory_Details_Key":"TS_CTE_HD","Results":[{"TestId":16120,"Result":50}]},{"SubCategoryKey":"THKS_A","SubCategory_Details_Key":"TS_ACT_HD","Results":[{"TestId":16120,"Result":50}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"PA_RA_QN","DetailsHidden_Key":"PA_RA_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_PRO_R_PRO_H"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_PRO_R_R_L"}],"CategoryKey":"PRO_R","SubCategoryList":[{"SubCategoryKey":"PRO_R_PRO","SubCategory_Details_Key":"PA_HD","Results":[{"TestId":16120,"Result":55}]},{"SubCategoryKey":"PRO_R_R","SubCategory_Details_Key":"RA_HD","Results":[{"TestId":16120,"Result":45}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"RO_QN","DetailsHidden_Key":"RO_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_RE_TK_TK_H"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_RE_TK_RE_L"}],"CategoryKey":"RE_TK","SubCategoryList":[{"SubCategoryKey":"RE_TK_RE","SubCategory_Details_Key":"RN_HD","Results":[{"TestId":16120,"Result":47}]},{"SubCategoryKey":"RE_TK_TK","SubCategory_Details_Key":"TK_HD","Results":[{"TestId":16120,"Result":53}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"PP_QN","DetailsHidden_Key":"PP_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_PPO_S_H"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_PPO_O_L"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_PPO_OB_L"}],"CategoryKey":"PPO","SubCategoryList":[{"SubCategoryKey":"PPO_S","SubCategory_Details_Key":"SF_HD","Results":[{"TestId":16120,"Result":70.5}]},{"SubCategoryKey":"PPO_O","SubCategory_Details_Key":"OS_HD","Results":[{"TestId":16120,"Result":46.5}]},{"SubCategoryKey":"PPO_OB","SubCategory_Details_Key":"OBS_HD","Results":[{"TestId":16120,"Result":33}]}]},{"MinThreshold":48,"MaxThreshold":52,"MinYAxis":26,"MaxYAxis":74,"DetailsVisible_Key":"TO_QN","DetailsHidden_Key":"TO_HD","Observations":[{"Order":0,"Type":"Single_High","Observation_Key":"LIFE_TIM_PA_H"},{"Order":1,"Type":"Single_Balance","Observation_Key":"LIFE_TIM_F_B"},{"Order":2,"Type":"Single_Low","Observation_Key":"LIFE_TIM_P_L"}],"CategoryKey":"TIM","SubCategoryList":[{"SubCategoryKey":"TIM_PA","SubCategory_Details_Key":"PT_HD","Results":[{"TestId":16120,"Result":79.5}]},{"SubCategoryKey":"TIM_P","SubCategory_Details_Key":"PRT_HD","Results":[{"TestId":16120,"Result":24}]},{"SubCategoryKey":"TIM_F","SubCategory_Details_Key":"FTR_HD","Results":[{"TestId":16120,"Result":48}]}]}]},"TestResultVMSurvey":{"SurveyQuestionList":[{"Key":"LONG_TERM","OptionsList":["1DL","1WL","1ML","6ML","1YL","3YL","5YL","10YL","20YL"],"SelectedOption":[{"TestId":16120,"ReplyKey":"20YL"}]},{"Key":"SHORT_TERM","OptionsList":["1DS","1WS","1MS","6MS","1YS","3YS","5YS","10YS","20YS"],"SelectedOption":[{"TestId":16120,"ReplyKey":"3YS"}]}]},"TestResult_2DGraphVM":[{"TestId":16120,"X":36,"Y":0}]}`
        const data = JSON.parse(dataAsStr);

        this.testInterpretationDataList.BarScatterGraph_Result = data.TestResultBar_Scatter_GraphVM;
        this.testInterpretationDataList.SurveyQuestion_Result = data.TestResultVMSurvey;
        this.testInterpretationDataList.TwoDiGraph_Result.TestResult_2DGraphVM = data.TestResult_2DGraphVM;
        this.testInterpretationDataList.UserInfo_Result = data.TestResult_UserInfoVM;
        this.testInterpretationDataList.IsSogileBurnout = data.IsSogileBurnoutCase;
    }

    validateTestToken = (token:string)=>{
        this.IsValidTestToken.inProgress = true;
        const url = URLConstants.ValidateTestToken + "?token="+token;
        return baseService
        .getRequest(url)
        .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
          if (response.data.Error) {
              this.error = response.data.Message;
              toast.error(formatMessage(response.data.Message));
              this.IsValidTestToken.success = false;
              this.IsValidTestToken.error = this.error;
          }
          else{
            this.IsValidTestToken.success = true;
            //   console.log(response)
          }
        })
        .catch((err: string) => {
            this.IsValidTestToken.error = err;
        //   console.log(err);
          toast.error(formatMessage(err));
        })
        .finally(action(() => {
             this.IsValidTestToken.inProgress = false;
        }));
      }

      resetValidateTestToken = () => {
        this.IsValidTestToken = { ...this.initialStateValue }
      }
    
    get allGraphData(): ICategoryInfo[] {
        if (this.testInterpretationDataList?.BarScatterGraph_Result && this.testInterpretationDataList.BarScatterGraph_Result?.CategoryList?.length > 0) {
            return toJS(this.testInterpretationDataList.BarScatterGraph_Result?.CategoryList).map((category: ICategoryInfo) => {
                return {
                    CategoryKey: category.CategoryKey,
                    MinThreshold: category.MinThreshold,
                    MaxThreshold: category.MaxThreshold,
                    MinYAxis: category.MinYAxis,
                    MaxYAxis: category.MaxYAxis,
                    DetailsVisible_Key: category.DetailsVisible_Key,
                    DetailsHidden_Key: category.DetailsHidden_Key,
                    SubCategoryList: category.SubCategoryList,
                    Observations: category.Observations,
                }
            });
        }
        return [];
    }

    get allSurveyData(): ISurveyQuestionInfo[] {
        if (this.testInterpretationDataList?.SurveyQuestion_Result && this.testInterpretationDataList.SurveyQuestion_Result?.SurveyQuestionList?.length > 0) {
            return toJS(this.testInterpretationDataList.SurveyQuestion_Result?.SurveyQuestionList).map((surveyQuestion: ISurveyQuestionInfo) => {
                return {
                    Key: surveyQuestion.Key,
                    OptionsList: surveyQuestion.OptionsList,
                    SelectedOption: surveyQuestion.SelectedOption
                }
            });
        }
        return [];
    }

    get allTestInfo(): ITestInfo[] {
        if (this.testInterpretationDataList?.UserInfo_Result && this.testInterpretationDataList.UserInfo_Result.TestDataListVM?.length > 0) {
            return toJS(this.testInterpretationDataList.UserInfo_Result?.TestDataListVM).map((testData: ITestInfo, index: number) => {
                return {
                    FirstName: testData.FirstName,
                    LastName: testData.LastName,
                    TestDate: testData.TestDate,
                    TestId: testData.TestId,
                    TestType: testData.TestType,
                    TrainerId: testData.TrainerId,
                    UserEmail: testData.UserEmail,
                    Color: (index < 10) ? this.colorsAsString[index].toString() : this.generateRandomColor(),
                    IsPaidTest: testData.IsPaidTest
                }
            })
        }
        return [];
    }

    generateHighchartColorPallete(): void {
        // Highcharts only have 10 colors in their colorPallete. So, if we want more than 10 colors, then we'll generate them randomly.
        // Check if Highcharts is defined
        if (typeof Highcharts !== 'undefined') {
            const defaultOptions = Highcharts.getOptions();
            if (defaultOptions && Array.isArray(defaultOptions.colors)) {
                // Convert hex colors to string format and assign it in an array.
                this.colorsAsString = [...defaultOptions.colors.map(color => Highcharts.color(color).get())];
            } else {
                console.error("Default colors not found or not an array");
            }
        } 
        else {
            console.error("Highcharts is not defined");
        }
    }


    hex2rgb = (c: any)=> `rgb(${c.match(/\w\w/g).map((x: any) => +`0x${x}`)})`;

    generateRandomColor(): string {
        let newRandomColorRGB: string = "";
        while (newRandomColorRGB === "" || this.colorsAsString.includes(newRandomColorRGB)) {
            const newRandomColorHex = "#" + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0').toUpperCase();
            newRandomColorRGB = this.hex2rgb(newRandomColorHex);
        }
        return newRandomColorRGB;
    }

    get allTwoDiResult(): ITwoDiGraphInfo[] {
        if (this.testInterpretationDataList?.TwoDiGraph_Result && this.testInterpretationDataList.TwoDiGraph_Result?.TestResult_2DGraphVM?.length > 0) {
            return toJS(this.testInterpretationDataList.TwoDiGraph_Result?.TestResult_2DGraphVM).map((twoDiGraphInfo: ITwoDiGraphInfo) => {
                return {
                    TestId: twoDiGraphInfo.TestId,
                    X: twoDiGraphInfo.X,
                    Y: twoDiGraphInfo.Y
                }
            });
        }
        return [];
    }

    get allQuestionList(): IQuestionInfo[] {
        if (this.questionDataList?.Questions && this.questionDataList.Questions?.length > 0) {
            let questionsArray = toJS(this.questionDataList?.Questions).map((question: IQuestionInfo) => {
                return {
                    Key: question.Key,
                    SubQuestions: question.SubQuestions,
                    OptionsList: question.OptionsList,
                    SelectedOption: question.SelectedOption
                };
            });
            let questionsArray_2 = toJS(this.questionDataList?.Questions_2).map((question: IQuestionInfo) => {
                return {
                    Key: question.Key,
                    SubQuestions: question.SubQuestions,
                    OptionsList: question.OptionsList,
                    SelectedOption: question.SelectedOption
                };
            });
            return [...questionsArray, ...questionsArray_2]
        }
        return [];
    }

    get allResultList(): IQuestionInfo[] {
        if (this.resultDataList?.Questions && this.resultDataList.Questions?.length > 0) {
            return toJS(this.resultDataList?.Questions).map((question: IQuestionInfo) => {
                return {
                    Key: question.Key,
                    SubQuestions: question.SubQuestions,
                    OptionsList: question.OptionsList,
                    SelectedOption: question.SelectedOption
                };
            });
        }
        return [];
    }

    /*
        Helper Function to format date
    */
    formatDate(date: Date) {
        // Reset a Date's time to midnight
        date.setHours(0, 0, 0, 0);
        return [
            date.getFullYear(),
            this.padTo2Digits(date.getMonth() + 1),
            this.padTo2Digits(date.getDate()),
        ].join('-');
    }

    // Format a date to YYYY-MM-DD (or any other format)
    padTo2Digits(num: Number) {
        return num.toString().padStart(2, '0');
    }
}

export default new TestStore();
